import { Component, Input } from '@angular/core';
import { SvgComponent } from '../../../../shared/components/svg/svg.component';

@Component({
  selector: 'app-action-box-icon',
  templateUrl: './action-box-icon.component.html',
  styleUrls: ['./action-box-icon.component.scss'],
  standalone: true,
  imports: [SvgComponent],
})
export class ActionBoxIconComponent {
  @Input() icon: string;
}
